import {
    BoolValue,
    StringValue,
} from 'google-protobuf/google/protobuf/wrappers_pb';
import Arg from '@livongo/arg';
import {UserVideoStatus} from '@livongo/protobuf-grpc-external-education';
import EnvironmentUtils from '@livongo/utils/environment';
import MixpanelUtils from '@livongo/utils/mixpanel';
import PropTypes from 'prop-types';
import YouTube from 'react-youtube';
import {useTranslation} from 'react-i18next';
import Button from 'ui/Button';

const IntroVideo = ({
    isOneApp,
    requestMetaData,
    onError,
    userActivityClient,
}) => {
    async function onWatchedStatusUpdate() {
        try {
            const userVideoStatus = new UserVideoStatus();
            const watched = new BoolValue();
            const videoName = new StringValue();

            videoName.setValue('DPP_INTRO');
            watched.setValue(true);
            userVideoStatus.setWatched(watched);
            userVideoStatus.setVideoName(videoName);

            await userActivityClient.updateVideoStatus(
                userVideoStatus,
                requestMetaData
            );

            MixpanelUtils.track({event: 'dppintrovideoscreen.play.clicked'});
        } catch (error) {
            onError();
        }
    }

    function handleMemberPortalRedirect() {
        const isProd =
            (window?.process?.env?.TGPS_ENV ?? process.env.NODE_ENV) ===
            'production';
        const host = window.location.hostname;
        const returnSubdomain = Arg('returnSubDomain');

        window.location.href = `${
            isOneApp
                ? isProd && host.endsWith('teladoc.com')
                    ? `${
                          window?.process?.env?.ONEAPP_URL ??
                          process.env.ONEAPP_URL
                      }/condition-management/home`
                    : `https://${returnSubdomain}/condition-management/home`
                : window?.process?.env?.MEMBER_PORTAL_URL ??
                  process.env.MEMBER_PORTAL_URL
        }`;

        MixpanelUtils.track({event: 'dppintrovideoscreen.done.clicked'});
    }

    const {t} = useTranslation();

    return (
        <div className="IntroVideo">
            <div className="IntroVideo-container">
                <YouTube
                    className="IntroVideo-video"
                    videoId={isOneApp ? 'dcgBC12PxOE' : 'DNHClL5zZZk'}
                    opts={{
                        width: '100%',
                    }}
                    onPlay={onWatchedStatusUpdate}
                />
                <div className="IntroVideo-content">
                    <h1 className="heading-md">{t('intro.video.heading')}</h1>
                    <ol>
                        <li>{t('intro.video.one')}</li>
                        <li>{t('intro.video.two')}</li>
                        <li>{t('intro.video.three')}</li>
                    </ol>
                </div>
                <div className="IntroVideo-action">
                    {!EnvironmentUtils.isMobileDevice() && (
                        <Button
                            color="primary"
                            onClick={handleMemberPortalRedirect}
                        >
                            {t('done')}
                        </Button>
                    )}
                </div>
            </div>
        </div>
    );
};

IntroVideo.propTypes = {
    isOneApp: PropTypes.bool,
    requestMetaData: PropTypes.object.isRequired,
    onError: PropTypes.func.isRequired,
    userActivityClient: PropTypes.object.isRequired,
};

export default IntroVideo;
